// Shared Application Data Store
// This acts as the central in-memory data source shared across all modules

export const PROJECTS = [
  { id: 1, name: "Sharma Residence - Sakchi", client: "Rajesh Sharma", budget: 500000, status: "Active", type: "Residential", startDate: "2024-01-15" },
  { id: 2, name: "Patel Office - sidhgora", client: "Sunil Patel", budget: 800000, status: "Active", type: "Office", startDate: "2024-02-10" },
  { id: 3, name: "Mehta Villa - Baridih", client: "Priya Mehta", budget: 1200000, status: "Active", type: "Villa", startDate: "2024-03-01" },
  { id: 4, name: "vijaya garden", client: "Anil Kapoor", budget: 350000, status: "Completed", type: "Residential", startDate: "2023-10-05" },
];

export const CLIENTS = [
  { id: 1, name: "Rajesh Sharma", mobile: "9876543210", email: "rajesh@email.com", city: "Jamshedpur" },
  { id: 2, name: "Sunil Patel", mobile: "9823456789", email: "sunil@email.com", city: "Jamshedpur" },
  { id: 3, name: "Priya Mehta", mobile: "9812345678", email: "priya@email.com", city: "Jamshedpur" },
  { id: 4, name: "Anil Kapoor", mobile: "9834567890", email: "anil@email.com", city: "Pune" },
];

export const WORKERS = [
  { id: 1, name: "Ramu Yadav", role: "Carpenter", mobile: "9011223344", salary: 25000, status: "Active" },
  { id: 2, name: "Shyam Verma", role: "Electrician", mobile: "9022334455", salary: 22000, status: "Active" },
  { id: 3, name: "Gopal Singh", role: "Painter", mobile: "9033445566", salary: 18000, status: "Active" },
  { id: 4, name: "Mohan Das", role: "Supervisor", mobile: "9044556677", salary: 35000, status: "Active" },
  { id: 5, name: "Lakhan Patel", role: "Carpenter", mobile: "9055667788", salary: 24000, status: "Inactive" },
];

export const INITIAL_SUPPLIERS = [
  { id: 1, supplierName: "Greenply Industries", contactPerson: "Vikram Shah", mobile: "9900112233", email: "vikram@greenply.com", gst: "27AABCG1234A1Z5", category: "Wood & Ply", city: "Jamshedpur", address: "MIDC, sidhgora", creditDays: 30, status: "Active" },
  { id: 2, supplierName: "Asian Paints Ltd", contactPerson: "Deepa Nair", mobile: "9911223344", email: "deepa@asianpaints.com", gst: "27AABCA5678B1Z3", category: "Paints", city: "Jamshedpur", address: "Bhandup Industrial Area", creditDays: 15, status: "Active" },
  { id: 3, supplierName: "Havells India", contactPerson: "Amit Gupta", mobile: "9922334455", email: "amit@havells.com", gst: "27AAACH9012C1Z1", category: "Electrical", city: "Delhi", address: "Okhla Industrial Estate", creditDays: 45, status: "Active" },
  { id: 4, supplierName: "Kajaria Ceramics", contactPerson: "Sunita Joshi", mobile: "9933445566", email: "sunita@kajaria.com", gst: "27AAACK3456D1Z9", category: "Tiles & Flooring", city: "Jaipur", address: "Mansarovar Industrial Area", creditDays: 30, status: "Active" },
  { id: 5, supplierName: "Saint Gobain Glass", contactPerson: "Rahul Mehta", mobile: "9944556677", email: "rahul@saintgobain.com", gst: "27AAACS7890E1Z7", category: "Glass & Mirrors", city: "Jamshedpur", address: "Kashidih", creditDays: 21, status: "Inactive" },
];

export const INITIAL_TRANSACTIONS = [
  {
    id: 1, date: "2024-03-01", projectId: 1, projectName: "Sharma Residence - Sakchi",
    type: "Cash In", category: "Client Advance",
    fromTo: "Rajesh Sharma", amount: 100000,
    remarks: "Initial advance from client", paymentMode: "NEFT", reference: "TXN001"
  },
  {
    id: 2, date: "2024-03-05", projectId: 1, projectName: "Sharma Residence - Sakchi",
    type: "Cash Out", category: "Labour Payment",
    fromTo: "Ramu Yadav", amount: 25000,
    remarks: "March carpenter advance", paymentMode: "Cash", reference: "TXN002"
  },
  {
    id: 3, date: "2024-03-08", projectId: 1, projectName: "Sharma Residence - Sakchi",
    type: "Cash Out", category: "Material Purchase",
    fromTo: "Greenply Industries", amount: 45000,
    remarks: "Plywood for modular kitchen", paymentMode: "Cheque", reference: "TXN003"
  },
  {
    id: 4, date: "2024-03-12", projectId: 2, projectName: "Patel Office - sidhgora",
    type: "Cash In", category: "Client Advance",
    fromTo: "Sunil Patel", amount: 200000,
    remarks: "50% project advance", paymentMode: "RTGS", reference: "TXN004"
  },
  {
    id: 5, date: "2024-03-15", projectId: 2, projectName: "Patel Office - sidhgora",
    type: "Cash Out", category: "Material Purchase",
    fromTo: "Asian Paints Ltd", amount: 38000,
    remarks: "Paint for office walls", paymentMode: "NEFT", reference: "TXN005"
  },
  {
    id: 6, date: "2024-03-18", projectId: 3, projectName: "Mehta Villa - Baridih",
    type: "Cash In", category: "Client Advance",
    fromTo: "Priya Mehta", amount: 300000,
    remarks: "25% advance for villa project", paymentMode: "RTGS", reference: "TXN006"
  },
  {
    id: 7, date: "2024-03-20", projectId: 3, projectName: "Mehta Villa - Baridih",
    type: "Cash Out", category: "Labour Payment",
    fromTo: "Mohan Das", amount: 35000,
    remarks: "Supervisor March salary", paymentMode: "Bank Transfer", reference: "TXN007"
  },
  {
    id: 8, date: "2024-03-22", projectId: 1, projectName: "Sharma Residence - Sakchi",
    type: "Cash Out", category: "Material Purchase",
    fromTo: "Havells India", amount: 28000,
    remarks: "Wiring & switches", paymentMode: "NEFT", reference: "TXN008"
  },
  {
    id: 9, date: "2024-03-25", projectId: 1, projectName: "Sharma Residence - Sakchi",
    type: "Cash In", category: "Client Payment",
    fromTo: "Rajesh Sharma", amount: 75000,
    remarks: "2nd installment", paymentMode: "NEFT", reference: "TXN009"
  },
  {
    id: 10, date: "2024-03-28", projectId: 2, projectName: "Patel Office - sidhgora",
    type: "Cash Out", category: "Supplier Payment",
    fromTo: "Kajaria Ceramics", amount: 62000,
    remarks: "Floor tiles for office", paymentMode: "Cheque", reference: "TXN010"
  },
];

export const TRANSACTION_CATEGORIES = {
  "Cash In": ["Client Advance", "Client Payment", "Final Settlement", "Refund Received", "Miscellaneous Income"],
  "Cash Out": ["Labour Payment", "Material Purchase", "Supplier Payment", "Overhead / Expense", "Refund Given", "Miscellaneous Expense"],
};

export const PAYMENT_MODES = ["Cash", "NEFT", "RTGS", "Cheque", "UPI", "Bank Transfer", "Card"];
